import React, { useContext, useEffect, useState } from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

import "./QuickStats.scss";

import { ModalContext } from "components/ModalContext";
import { getDetailedSelectionInfo } from "utils/builder/IScheduleLogic";
import QuickStatsItem from "components/uiComponents/QuickStatsItem";
import QuickStatsModal from "components/modals/QuickStatsModal";


const QuickStats = ({
  quickCounterData,
  isCompare,
  sidebarIsOpened,
  isAdvanceFilterOpen = false,
}) => {
  const { t } = useTranslation();

  const [details, setDetails] = useState(null);
  const { handleModal } = useContext(ModalContext);
  const { compare } = useSelector((state) => state.viewer);

  const handleCloseModal = () => {
    handleModal(null, true);
  };

  const handleDetails = () => {
    handleModal(
      <QuickStatsModal
        title={t('selection_details')}
        closeModal={handleCloseModal}
        data={details}
      />,
      false,
      true
    );
  };

  useEffect(() => {
    const computeData = async () => {
      let newDetails = null;

      if (isCompare) {
        newDetails = compare.selectionDetails.map((el) => { return { info: el.infoCollection, sumCategories: el.sumCategories, color: el.color, name: el.name } });
      } else {
        newDetails = [{ info: getDetailedSelectionInfo(), sumCategories: null, color: null, name: null }];
      }

      setDetails(newDetails);
    }

    computeData()
  }, [quickCounterData, compare.selectionDetails.length]);

  return (
    <div
      className={classNames({
        "quick-stats": true,
        "quick-stats--replaced": !sidebarIsOpened,
        "quick-stats--open-side-bar": isAdvanceFilterOpen,
      })}
    >
      <div className="quick-stats__wrapper">
        {quickCounterData &&
          quickCounterData.map(({ value, name, percentage, unit }) => (
            <QuickStatsItem
              value={value}
              name={name}
              percent={percentage}
              key={name + value}
              unit={unit}
            />
          )
          )}
      </div>

      {details?.length !== 0 &&
        <div
          className="quick-stats__details"
          onClick={handleDetails}
        >
          {t('selection_details')}
        </div>
      }
    </div>
  );
};

export default QuickStats;
